import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { de } from './locales/de';
import { en } from './locales/en';
import { adminDe } from './locales/admin.de';
import { adminEn } from './locales/admin.en';

export const SUPPORTED_LANGUAGES = ['de', 'en'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_LABELS: Record<Language, string> = { de: 'Deutsch', en: 'English' };

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de, admin: adminDe },
      en: { translation: en, admin: adminEn },
    },
    fallbackLng: 'de',
    supportedLngs: SUPPORTED_LANGUAGES,
    // The site is German-first; only fall back to English on an explicit choice.
    nonExplicitSupportedLngs: true,
    defaultNS: 'translation',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'pv-language',
      caches: ['localStorage'],
    },
    returnObjects: true,
  });

/**
 * Keeps <html lang> in sync for screen readers and SEO. Set once on init too:
 * `languageChanged` does not fire for the initially detected language, which
 * otherwise leaves index.html's hardcoded lang="de" on an English page.
 */
const syncDocumentLang = (lng?: string) => {
  document.documentElement.lang = lng ?? 'de';
};

syncDocumentLang(i18n.resolvedLanguage);
i18n.on('languageChanged', syncDocumentLang);

export default i18n;
